import { Node, mergeAttributes } from "@tiptap/core";
import { ReactNodeViewRenderer } from "@tiptap/react";
import { promptMentionChipClassName } from "./PromptMentionChip";
import { SkillMentionNodeView } from "./SkillMentionNodeView";

/**
 * Atomic inline skill chip. The caret sits before or after the node, never
 * inside `/{slug}`. Submit still serializes to `/${slug}`.
 */
export const SkillMentionNode = Node.create({
  name: "skillMention",
  group: "inline",
  inline: true,
  atom: true,
  selectable: true,

  addAttributes() {
    return {
      id: {
        default: "",
        parseHTML: (element) => element.getAttribute("data-skill-id") ?? "",
      },
      name: {
        default: "",
        parseHTML: (element) => element.getAttribute("data-skill-name") ?? "",
      },
      slug: {
        default: "",
        parseHTML: (element) => element.getAttribute("data-skill-slug") ?? "",
      },
    };
  },

  parseHTML() {
    return [{ tag: "span[data-skill-id][data-skill-slug]" }];
  },

  renderHTML({ HTMLAttributes }) {
    const { id, name, slug, ...rest } = HTMLAttributes;
    return [
      "span",
      mergeAttributes(rest, {
        "data-skill-id": id,
        "data-skill-slug": slug,
        "data-skill-name": name,
        class: promptMentionChipClassName,
      }),
      `/${slug ?? ""}`,
    ];
  },

  renderText({ node }) {
    const slug = typeof node.attrs.slug === "string" ? node.attrs.slug : "";
    return slug ? `/${slug}` : "";
  },

  addNodeView() {
    return ReactNodeViewRenderer(SkillMentionNodeView);
  },
});
